<script lang="ts">
    import { onMount } from "svelte"
    import { createEventDispatcher } from "svelte"
    import Icon from "../Icon.svelte"
    import { mdiPencilOutline } from "@mdi/js"

    export let cssClass: string = ""
    export let label: string
    export let value: string
    export let type: string = "text"
    export let readonly: boolean = false
    export let required: boolean = false
    export let showAsEditable: boolean = false
    export let fieldMdiIcon: string = mdiPencilOutline
    export let inputMdiIcon: string = null
    export let invalid: boolean = false
    export let decimal: number = null
    export let noIcon: boolean = false

    let input: HTMLInputElement
    const dispatch = createEventDispatcher()

    onMount(() => {
        input.type = type
    })

    // By writing
    const onEnter = (e: Event) => {
        if (required && (e.target as HTMLInputElement).value === "") {
            invalid = true
            dispatch("invalid")
        } else {
            invalid = false
            dispatch("updated", (e.target as HTMLInputElement).value)
        }
    }

    const onBlur = (e: Event) => {
        if (type === "number" && decimal) {
            value = Number.parseFloat((e.target as HTMLInputElement).value).toFixed(decimal)
        }
    }

    const onChange = (e: Event) => {
        if (type === "number" && decimal) {
            value = Number.parseFloat((e.target as HTMLInputElement).value).toFixed(decimal)
        }
        dispatch("changed", value)
    }

    const onKeyPress = (e: KeyboardEvent) => {
        if (type === "number" && decimal) {
            value = Number.parseFloat((e.target as HTMLInputElement).value).toFixed(decimal)
        }

        if (e.key === "Enter") {
            dispatch("enter", value)
        }
    }
</script>

<div class="edit-field transparent {cssClass}" role="button" tabindex="0" class:invalid on:click on:keydown>
    <label for="">{label}</label>
    <div class="edit-field-input-group">
        <input
            class="edit-field-input"
            class:width-input-icon="{inputMdiIcon}"
            bind:value
            class:showed-as-editable="{showAsEditable}"
            {readonly}
            {required}
            bind:this="{input}"
            on:click|stopPropagation
            on:input="{onEnter}"
            on:blur="{onBlur}"
            on:keypress="{onKeyPress}"
            on:change="{onChange}"
            name="{label}"
        />

        {#if inputMdiIcon}
            <div class="edit-field-input-icon">
                <Icon path="{inputMdiIcon}" size="18px" />
            </div>
        {/if}
        {#if !noIcon}
            <div role="button" tabindex="0" on:click|stopPropagation="{() => input.focus()}" on:keydown>
                <Icon path="{fieldMdiIcon}" size="24px" />
            </div>
        {/if}
    </div>
</div>
